import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faArrowDown,
  faArrowRight,
  faArrowUp,
  faAsterisk,
  faCalendar,
  faCalendarAlt,
  faCheck,
  faCheckCircle,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faCircle,
  faClock,
  faCog,
  faCopy,
  faDownload,
  faExchangeAlt,
  faExclamationCircle,
  faExclamationTriangle,
  faHome,
  faInfoCircle,
  faMoneyBillAlt,
  faPen,
  faPlay,
  faPlus,
  faPlusCircle,
  faSearch,
  faStop,
  faStore,
  faSync,
  faTicketAlt,
  faTimes,
  faTimesCircle,
  faTrash,
  faTrashAlt,
  faUser,
  faUsers,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import styled from 'styled-components';

library.add(
  faCalendar,
  faCalendarAlt,
  faDownload,
  faInfoCircle,
  faArrowUp,
  faArrowDown,
  faArrowRight,
  faSync,
  faCog,
  faMoneyBillAlt,
  faHome,
  faExchangeAlt,
  faUsers,
  faCheckCircle,
  faTimesCircle,
  faPlusCircle,
  faExclamationCircle,
  faPen,
  faExclamationTriangle,
  faUser,
  faCheck,
  faTimes,
  faCopy,
  faAsterisk,
  faChevronDown,
  faCircle,
  faTrash,
  faTrashAlt,
  faPlus,
  faChevronLeft,
  faChevronRight,
  faClock,
  faSearch,
  faStore,
  faTicketAlt,
  faPlay,
  faStop
);

type Props = {
  className?: string;
} & React.ComponentProps<typeof FontAwesomeIcon>;

const FA = ({ className, ...props }: Props) => {
  return (
    <span className={`font-awesome-icon ${className}`}>
      <FontAwesomeIcon {...props} />
    </span>
  );
};

export default styled(FA)`
  display: inline-block;
`;
